import React from "react";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import DatasetLinkedOutlinedIcon from "@mui/icons-material/DatasetLinkedOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import ViewComfyOutlinedIcon from "@mui/icons-material/ViewComfyOutlined";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import FunctionsIcon from "@mui/icons-material/Functions";
import { ModelItemInstanceJS, TableSourceJS } from "target_wasm";
import { isConnectorSource } from "../canvas/utils/roles";

const IMPORTED_SOURCES: TableSourceJS[] = [
  TableSourceJS.Imported,
  TableSourceJS.ImportedInactive,
  TableSourceJS.ImportedWaitingForApproval,
  // A PendingRelease reservation is still an import (viewless, awaiting the
  // source's first release) — show the linked-dataset icon, not the plain
  // table icon. DElement tints it to signal the waiting state.
  TableSourceJS.ImportedPendingRelease,
];

interface ItemInstanceIconProps {
  instance: ModelItemInstanceJS;
  source?: TableSourceJS;
  className?: string;
  style?: React.CSSProperties;
}

export function ItemInstanceIcon({
  instance,
  source,
  className = "icon-sm",
  style,
}: ItemInstanceIconProps) {
  switch (instance) {
    case ModelItemInstanceJS.Table:
      if (source === TableSourceJS.RecipeResult) {
        return <FunctionsIcon className={className} style={style} />;
      }
      if (source && isConnectorSource(source)) {
        return <StorageOutlinedIcon className={className} style={style} />;
      }
      if (source && IMPORTED_SOURCES.includes(source)) {
        return (
          <DatasetLinkedOutlinedIcon className={className} style={style} />
        );
      }
      return <TableChartOutlinedIcon className={className} style={style} />;
    case ModelItemInstanceJS.TableView:
      if (source === TableSourceJS.RecipeResult) {
        return <FunctionsIcon className={className} style={style} />;
      }
      return <ViewComfyOutlinedIcon className={className} style={style} />;
    case ModelItemInstanceJS.TableDiffView:
      return <CompareArrowsIcon className={className} style={style} />;
    default:
      return <TableChartOutlinedIcon className={className} style={style} />;
  }
}
